import locations from '@/apis/kitchens/locations'
import { locationsTypes } from '@/store/mutationTypes'

export default {
    namespaced: true,
    state: {
        fetchAll: {
            pending: false,
            error: null,
        },
    },
    mutations: {
        [locationsTypes.FETCH_ALL_REQUEST]: function (state) {
            state.fetchAll.pending = true;
        },
        [locationsTypes.FETCH_ALL_SUCCESS]: function (state) {
            state.fetchAll.error = null;
            state.fetchAll.pending = false;
        },
        [locationsTypes.FETCH_ALL_FAILURE]: function (state, error) {
            state.fetchAll.error = error;
            state.fetchAll.pending = false;
        },
    },
    actions: {
        async fetchAll({ commit }, payload) {
            commit(locationsTypes.FETCH_ALL_REQUEST)
            return new Promise((resolve, reject) => {
                locations
                    .fetchAll(payload.nested)
                    .then((locationsList) => {
                        commit(locationsTypes.FETCH_ALL_SUCCESS)
                        resolve(locationsList.data)
                    })
                    .catch((error) => {
                        commit(locationsTypes.FETCH_ALL_FAILURE, error)
                        reject(error)
                    })
            })
        },
    }
}